import { Enumeration } from '../../utils/AppEnum';

export class WorkflowState extends Enumeration<WorkflowState> {
	
	public static Submitted = new WorkflowState('Submitted', 0);

	public static Approved = new WorkflowState('Approved', 1);

	public static Rejected = new WorkflowState('Rejected', 2);

	public static Error = new WorkflowState('Error', 3);

	public static PendingDeletion = new WorkflowState('Pending Deletion', 4);

	public static Deleted = new WorkflowState('Deleted', 5);

	public static Disabled = new WorkflowState('Disabled', 6);

	public static PastDue = new WorkflowState('PastDue', 7);

	public static Warned = new WorkflowState('Warned', 8);

	public static Enabled = new WorkflowState('Enabled', 201);

	public static PendingSubscriptionOwnerApproval = new WorkflowState("Pending subscription owner approval", 400);

	public static PendingForDOAGApproval = new WorkflowState('Pending Business DOAG Approval', 401);

	public static PendingForCloudNetworkApproval = new WorkflowState('Pending for Cloud Network Approval', 402);

	public static PendingForPolicyTeamApproval = new WorkflowState('Pending for Policy Team Approval', 403);

	public static Review = new WorkflowState('Review', 404);
	
	public static AwaitingImplementation = new WorkflowState('Awaiting Implementation', 405);
	
	public static Completed = new WorkflowState('Completed', 406);

	public static PendingForTechnicalReview = new WorkflowState('Pending for Technical Review', 407);
	
	public static Cancelled = new WorkflowState('Cancelled', 408);
	
	public static Draft = new WorkflowState('Draft', 409);
	
	public static ImplementationFailed = new WorkflowState("Implementation Failed", 410);
	
	public static PendingCloudArchitectApproval = new WorkflowState('Pending for Cloud Architect Approval', 411);
	
	public static PendingForCyberApproval = new WorkflowState('Pending for Cyber Team Approval', 412);
	
	public static PendingAttestation = new WorkflowState("Pending Attestation", 413);

	public static PendingAccountOwnerApproval = new WorkflowState("Pending Account owner approval", 414);

	public static PendingNetworkPolicyApproval = new WorkflowState("Pending Network Policy Approval", 415);

	public static PendingSolutionArchitectureApproval = new WorkflowState("Pending Network Policy Solution Architecture approval", 416);

	public static PendingOTCRMApproval  = new WorkflowState("Pending Operations Technology Cybersecurity Risk Management approval", 418);

	public static PendingAppEndorserApproval = new WorkflowState("Pending Application Owner approval", 419);

	public static PendingConnOwnerApproval = new WorkflowState("Pending Network Connection Owner approval", 420);

	public static PendingProxyArchitectApproval = new WorkflowState("Pending Proxy Architect approval", 421);

	public static PendingNetSecPolicyApproval = new WorkflowState("Pending Network Security Policy approval", 422);

	public static PendingPDArchitectApproval = new WorkflowState("Pending Platforms Delivery Architect approval", 423);

	public static PendingPlatformsArchitectApproval = new WorkflowState("Pending Platforms Architect approval", 424);

	public static PendingAwsPlatformsApproval = new WorkflowState("Pending Aws Platforms approval", 425);

	public static PendingAwsConnectivityDetails = new WorkflowState("Pending Aws Connectivity Details", 426);

	public static PendingDmzImplementation = new WorkflowState("Pending DMZ Implementation", 427);

	public static PendingSecondaryAccountOwnerApproval = new WorkflowState("Pending Secondary Account owner approval", 428);

	public static PendingNewAccountOwnerApproval = new WorkflowState("Pending New Account Owner Approval", 429);

	public static PendingCurrentAccountOwnerApproval = new WorkflowState("Pending Current Account Owner Approval", 430);

	public static AwaitingChangesImplementation = new WorkflowState("Awaiting Changes Implementation", 431);

	public static PendingAccountGroupsApproval = new WorkflowState("Pending Account Groups Approval", 432);

	public static AwaitingOwnerDeletionApproval = new WorkflowState("Awaiting Owner Deletion Approval", 434);

    public static AwaitingDeletion =  new WorkflowState("Awaiting Deletion", 435);

	public static Expired =  new WorkflowState("Expired", 437);

    public static PendingTier0ArchitectApproval  =  new WorkflowState("Pending Tier0 Architect Approval", 438);

	public static PendingVaultTeamApproval  =  new WorkflowState("Pending Vault Team Approval", 439);

	public static PendingApplicationApproval = new WorkflowState("Pending Application Approval", 436);

	public static PendingASAApproval = new WorkflowState("Pending ASA Approval", 450);

	public static PendingCSCApproval = new WorkflowState("Pending CSC Approval", 451);

	public static PendingAIApproval = new WorkflowState("Pending AI Approval", 452);

	public static PendingAVDApproval = new WorkflowState("Pending AVD Approval", 453);

	public static PendingAKSACIApproval = new WorkflowState("Pending AKS/ACI Approval", 454);

	public static PendingDataIntegrationApproval = new WorkflowState("Pending Data Integration Approval", 455);

}